import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useCoinsBannerStateManager = () => {
  return useOpenedStateManager('COINS_BANNER');
};
